import { connect } from 'react-redux'
import { compose } from 'redux'
import toJS from '../../hoc/toJS'
import Translation from '../Translation/cont/Translation'
import getTranslationStringById from '../Translation/func/getTranslationStringById'

const SEARCH_LABEL_TRANS_ID = 'preview_movies_search_label'

export const SearchInputComponent = ({
    value, onChange, placeholderTransId, width, autoFocus,
    translationStrings, currentLang, debug,
}) => {
    const placeholder = getTranslationStringById(placeholderTransId, translationStrings, currentLang, '', debug)

    return (
        <div className="search-input-group">
            <span className="search-input-label text-light-uppercase"><Translation id={SEARCH_LABEL_TRANS_ID} /></span>
            <input
                type="text"
                className="search-input-field"
                style={width ? { width } : undefined}
                placeholder={placeholder}
                value={value}
                onChange={e => onChange(e.target.value)}
                autoFocus={!!autoFocus}
            />
        </div>
    )
}

const mapStateToProps = (state) => ({
    translationStrings: state.getIn(['translation', 'strings']),
    currentLang: state.getIn(['translation', 'currentLang']),
    debug: state.getIn(['translation', 'debug']),
})

export default compose(
    connect(mapStateToProps, null),
    toJS(),
)(SearchInputComponent)
